import useTrackPassive from './useTrackPassive'

export default function TrackPassive() {
  useTrackPassive()
  return null
}
